/* ==========================================================================
   HOME PASSION · cekmece acilis animasyonu

   Satirlar soldan sirayla giriyor, en altta kampanya bandi. CSS animasyonu
   kullanamiyoruz: satirlar cekmece kapaliyken de DOM'da duruyor, sayfa
   acilirken bosuna oynardi. Bu yuzden sinif acilma aninda JS ile veriliyor.
   ========================================================================== */
(function(){
  'use strict';

  function items(){
    return [].slice.call(document.querySelectorAll('.hp-drawer .hp-dr-row, .hp-drawer .hp-dr-promo'));
  }

  function play(){
    items().forEach(function(el,i){
      el.classList.remove('in');
      setTimeout(function(){ el.classList.add('in'); }, 60 + i*48);
    });
  }
  function reset(){ items().forEach(function(el){ el.classList.remove('in'); }); }

  document.addEventListener('click', function(e){
    if(e.target.closest('.hp-burger')){ setTimeout(play, 120); return; }
    if(e.target.closest('.hp-drawer [data-close]') || e.target.closest('.hp-scrim')){
      setTimeout(reset, 320);
    }
  }, true);

  function watch(){
    var dr = document.querySelector('.hp-drawer');
    if(!dr || dr.dataset.hpWatch) return;
    dr.dataset.hpWatch = '1';
    var was = false;
    new MutationObserver(function(){
      var open = dr.getBoundingClientRect().left < window.innerWidth - 40;
      if(open && !was){ play(); }
      if(!open && was){ reset(); }
      was = open;
    }).observe(dr, {attributes:true, attributeFilter:['class','style']});
  }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', watch); }
  else { watch(); }
  document.addEventListener('shopify:section:load', watch);
})();
